<template>
    <div v-transfer-dom :data-transfer="true" :class="prefixCls">
        <transition name="fade">
            <div :class="`${prefixCls}-mask`" 
                :style="{ 'z-index': 1010 + handleGetIndex()}" 
                v-if="visible"></div>
        </transition>
        <div :class="`${prefixCls}-wrapper`" 
            :style="{ 'z-index': 1010 + handleGetIndex()}" 
            v-show="wrapShow">
            <transition name="move-up">
                <div :class="`${prefixCls}-inner`" v-if="visible">
                    <div :class="`${prefixCls}-inner-header`">
                        <div :class="`${prefixCls}-inner-title`">
                            <slot name="header">
                                {{title}}
                            </slot>
                        </div>
                        <div v-if="closeable" 
                            :class="`${prefixCls}-inner-close`"
                            @click="handleCancel">
                            <Icon type="cross"/>
                        </div>
                    </div>
                    <div :class="`${prefixCls}-inner-body`">
                        <template v-if="render">
                            <render-cell :render="render" />
                        </template>
                        <slot v-else>{{content}}</slot>
                    </div>
                    <div :class="`${prefixCls}-inner-footer`">
                        <slot name="footer">
                            <Button :type="type === 'confirm' ? 'default' : 'primary'"
                                @click="handleCancel">
                                {{type === 'confirm' ? t('cancel') : t('close')}}
                            </Button>
                            <Button v-if="type === 'confirm'" 
                                type="primary" 
                                @click="handleOk"
                                :loading="btnLoading"
                                style="margin-left: 4px">
                                {{t('ok')}}
                            </Button>
                        </slot>
                    </div>
                </div>
            </transition>
        </div>
    </div>
</template>
<script>
    import RenderCell from '../../base/common/render'
    import Button from '../../base/button/'
    import Icon from '../../base/icon/'
    import TransferDom from '../../../directives/transfer-dom'
    import locale from '../../../mixins/locale'
    import { oneOf } from '../../../utils/assist'
    import { transferIndex, transferIncrease } from '../../../utils/transfer-queue'

    const prefixCls = 'yy-modal'
    export default {
        name: 'YYModal',
        props: {
            value: {
                type: Boolean,
                default: false
            },
            loading: { // 是否异步
                type: Boolean,
                default: false
            },
            title: {
                type: String,
            },
            content: {
                type: String,
            },
            render: {
                type: Function
            },
            type: { // 对话框类型 confirm alert
                validator: function(value) {
                    return oneOf(value, ['confirm', 'alert'])
                },
                default: 'confirm'
            },
            closeable: { // 是否显示右上角关闭按钮
                type: Boolean,
                default: true
            },
            onCancel: {
                type: Function,
                default: ()=>{}
            },
            onOk: {
                type: Function,
                default: ()=>{}
            }
        },
        mixins: [locale],
        data() {
            return {
                prefixCls: prefixCls,
                visible: this.value,
                wrapShow: false,
                btnLoading: false,
            }
        },
        components: {
            RenderCell,
            Button,
            Icon
        },
        directives: {
            TransferDom
        },
        watch: {
            value (value) {
                this.visible = value
            },
            visible (value) {
                if(value) {
                    this.wrapShow = true
                } else {
                    setTimeout(() => {
                        this.wrapShow = false
                    }, 300)
                }
            }
        },
        methods: {
            handleCancel() {
                this.visible = false
                this.$emit('input', this.visible)
                this.onCancel()
                this.$emit('on-cancel')
            },
            handleOk() {
                if(this.btnLoading) return
                if(this.loading) {
                    this.btnLoading = true
                } else {
                    this.visible = false
                    this.$emit('input', this.visible)
                }
                this.onOk()
                this.$emit('on-ok')
            },
            handleGetIndex () {
                transferIncrease()
                return transferIndex
            }
        }
    }
</script>





// WEBPACK FOOTER //
// src/components/base/modal/modal.vue